import { toastService } from "src/libraries/toast";
import { forceUpdateService } from "../entity/platforms/ForceUpdateService";
import { forceUpdateModel } from "../entity/platforms/ForceUpdateModel";
import { convertToArrayPlatforms } from "../presenters/convertToArrayPlatforms";

export const getForceUpdateUseCase = async () => {
    try {
        const response = await forceUpdateService.list();
        if (response?.isError) {
            toastService.onError('Some error');
        } else {
            const platforms = convertToArrayPlatforms(response.data);
            forceUpdateModel.platforms = platforms;
        }
    } catch (error) {
        console.warn('getForceUpdateUseCase: ', error);
    }
};